import { render, staticRenderFns } from "./RoughSketch.vue?vue&type=template&id=c3b04e8e&scoped=true&"
import script from "./RoughSketch.vue?vue&type=script&lang=js&"
export * from "./RoughSketch.vue?vue&type=script&lang=js&"
import style0 from "./RoughSketch.vue?vue&type=style&index=0&id=c3b04e8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b04e8e",
  null
  
)

export default component.exports